/** Kategorie-Symbole der Kachel (aus Kachel.tsx ausgelagert, W82-2 N3: auch der Fakt „ablegen unter …“ der Pruefkarte nimmt
 *  sie). */
import {
  BadgeCheck,
  Banknote,
  BriefcaseBusiness,
  BriefcaseMedical,
  FileText,
  GraduationCap,
  House,
  Inbox,
  Landmark,
  Megaphone,
  Shield,
  ShoppingBag,
  TrainFront,
  TriangleAlert,
  Users,
  type LucideIcon,
} from "lucide-react";
import type { IconTyp } from "./Briefgeist";

/** Kategorie-Symbol (Lucide-Entsprechung der App-Symbole). Kategorien sind neutral (Handoff Schiefer,
 *  catTint: transparent, Symbol in --pg-text-2; Plan 6.7, F11): Farbe bleibt Zustaenden, Handlung und KI. */
export const KATEGORIEN: Record<string, LucideIcon> = {
  forderungen: TriangleAlert,
  gesundheit: BriefcaseMedical,
  behoerden: Landmark,
  arbeit: BriefcaseBusiness,
  nachweise: BadgeCheck,
  versicherung: Shield,
  wohnen: House,
  vertraege: FileText,
  bank: Banknote,
  werbung: Megaphone,
  sonstiges: Inbox,
  // W56 (Buendel S7): vier neue Kategorien des Servers
  einkaeufe: ShoppingBag,
  mobilitaet: TrainFront,
  bildung: GraduationCap,
  mitgliedschaften: Users,
};

/** Symbol der Kategorie wie in der Kachel; ohne Kategorie der Brief. */
export function kategorieSymbol(schluessel: string | null | undefined): IconTyp {
  return (schluessel ? KATEGORIEN[schluessel] : undefined) ?? FileText;
}
